'use-client';
import * as React from 'react';
import classNames from 'clsx';
import { getDataAttributes } from '@wix/editor-elements-common-utils';
import type { IResponsivePopupPageProps } from '../ResponsivePopupPage.types';
import ResponsiveContainer from '@wix/thunderbolt-elements/components/ResponsiveContainer';
import { TestIds } from '../constants';
import style from './style/ResponsivePopupPage.scss';

const PopupPage: React.FC<IResponsivePopupPageProps> = props => {
  const {
    id,
    className,
    pageDidMount,
    onClick,
    children,
    containerProps,
    withOverlay = true,
  } = props;

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(className, style.root, {
        [style.clickable]: onClick,
      })}
      ref={pageDidMount}
      data-block-level-container="PopupPage"
    >
      {withOverlay && (
        <div
          className={style.overlay}
          onClick={onClick}
          data-testid={TestIds.ResponsivePopupPageOverlay}
        />
      )}
      <ResponsiveContainer
        {...containerProps}
        extraRootClass={style.responsiveContainer}
      >
        {() => <div className={style.lightboxLayer}>{children()}</div>}
      </ResponsiveContainer>
    </div>
  );
};

export default PopupPage;
